var actions = [];

const actionQueue = store => next => action => {

    let actionObj = {
        action: action,
        time: getTimeString()
    }

    actions.push(actionObj);
    if (actions.length > 100) {
        actions.shift();
    }

    let result = next(action)
    return result
}

function getTimeString() {
    var date = new Date();
    var min = "" + date.getMinutes();
    var sec = "" + date.getSeconds();
    var mil = "" + date.getMilliseconds();
    if (mil.length === 1) mil = "00" + mil;
    if (mil.length === 2) mil = "0" + mil;
    var x = "" + date.getHours() + ":" + (min.length === 1 ? "0" + min : min) + ":" + (sec.length === 1 ? "0" + sec : sec) + "." + mil;
    return x;
}

export function getQueue() {
    return actions;
}


export default actionQueue